import React from 'react';

interface ArrowIconProps {
  direction?: 'left' | 'right';
}

const ArrowIcon: React.FC<ArrowIconProps> = ({ direction = 'right' }) => {
    const styles = {
        transform: direction === "left" ? "none" : "scaleX(-1)", // Use CSS transform
        transformOrigin: "center",
      };

  return (
    <svg style={styles} width="28" height="28" viewBox="0 0 29 29" fill="none" xmlns="http://www.w3.org/2000/svg">
      <circle
        cx="13"
        cy="13"
        r="13"
        transform="matrix(-1 0 0 1 27.437 1.80005)"
        fill="white"
        stroke="#FA6400"
        stroke-width="2"
      />
      <path
        d="M17.3403 10.9495L16.1719 9.80002L10.6307 15.2516L16.1719 20.7032L17.3403 19.5538L12.9674 15.2516L17.3403 10.9495Z"
        fill="#404040"
      />
      <mask
        id="mask0_1_10667"
        style={{ maskType: "luminance" }}
        maskUnits="userSpaceOnUse"
        x="10"
        y="9"
        width="8"
        height="12"
      >
        <path
          d="M17.3403 10.9495L16.1719 9.80002L10.6307 15.2516L16.1719 20.7032L17.3403 19.5538L12.9674 15.2516L17.3403 10.9495Z"
          fill="white"
        />
      </mask>
      <g mask="url(#mask0_1_10667)"></g>
    </svg>
  );
};

export default ArrowIcon;